import { includes } from "lodash";
import { position } from "polished";
import React, { useEffect, useRef, useCallback } from "react";
import './timebar.scss';
import { ColumnsIcon } from "lucide-react";
import { exportedTextColor } from "./view";

export const CreateTimeBar = ({ name, startTime, endTime, backgroundColor, yearData, selectedYear, onLineClick}) => {
    // console.log("Creating timeline with:", { name, startTime, endTime, backgroundColor, yearData });

    const TIMEBAR_EON = {
        fontWeight: '400',
        color: exportedTextColor
    }

    const timebarRef = useRef(null);
    const onLineClickRef = useRef(onLineClick);
    onLineClickRef.current = onLineClick;

    useEffect(() => {
        const timebar = timebarRef.current;
        if (!timebar) return;

        const timebarWidth = timebar.offsetWidth;

        function getLinePosition(year) {
            const timeDuration = startTime - endTime;
            const relativePosition = (startTime - year) / timeDuration;
            return relativePosition * timebarWidth;
        }

        function createVerticalLine(year) {
            const line = document.createElement("div");
            const isActive = `${year}` === `${selectedYear}`;
            line.className = isActive ? "vertical-line vertical-line--active" : "vertical-line";
            line.style.left = `${getLinePosition(year)}px`;

            line.addEventListener("click", (e) => {
                e.preventDefault();
                if(onLineClickRef.current) {
                    onLineClickRef.current(year);
                }
            });

            timebar.appendChild(line);
        }

        // 清除已有的垂直线，避免重复渲染
        timebar.querySelectorAll(".vertical-line").forEach(line => line.remove());

        // 创建新的垂直线
        yearData.forEach((year) => createVerticalLine(year));

    }, [startTime, endTime, backgroundColor, yearData, selectedYear]);

    return (
        <div className="panel-timebar-root">
            <div ref={timebarRef} style={{ backgroundColor: backgroundColor }} className="timebar-style" id="timebar">
                <div className="start-time">{startTime}Mya</div>
                <div style={TIMEBAR_EON}>{name}</div>
                <div className="end-time">{endTime}Mya</div>
            </div>
        </div>

    )
}